<template>
  <app-shell breadcrumbs="Home">
    <div class="row no-gutters mt-4">
      <div class="col-12">
        <collapsible-card title="Welcome to Tingg Developer Portal" collapsible="true">
          <div class="ml-jumbotron">
            <div class="ml-jumbotron__title">
              Welcome to Tingg Developer Portal
            </div>
            <div class="ml-jumbotron__body">
              <div class="ml-jumbotron__icon-list">
                <div class="icon-list-item router-link-item" @click="goTo('/documentation/express')">
                  <div class="icon-list-item__icon">
                    <i class="material-icons-outlined">map</i>
                  </div>
                  <div class="icon-list-item__title">
                    Learn your way around
                  </div>
                  <div class="icon-list-item__content">
                    Read our docs and be guided on how you will integrate our checkout to your web or mobile application
                  </div>
                </div>
                <div class="icon-list-item router-link-item" @click="goTo('/visits')">
                  <div class="icon-list-item__icon">
                    <i class="material-icons">timeline</i>
                  </div>
                  <div class="icon-list-item__title">
                    Track customer visits
                  </div>
                  <div class="icon-list-item__content">
                    Track the behaviour of your customers on checkout and get a view of their
                    preferences and track the effects of your changes
                  </div>
                </div>
                <div class="icon-list-item router-link-item" @click="goTo('/users')">
                  <div class="icon-list-item__icon">
                    <i class="material-icons-outlined">people</i>
                  </div>
                  <div class="icon-list-item__title">
                    Manage your team
                  </div>
                  <div class="icon-list-item__content">
                    Manage your team by adding or removing users that can access this portal
                    or changing their roles.
                  </div>
                </div>
                <div class="icon-list-item router-link-item" @click="goTo('/payment/options')">
                  <div class="icon-list-item__icon">
                    <i class="material-icons-outlined">account_balance_wallet</i>
                  </div>
                  <div class="icon-list-item__title">
                    Manage your payment options
                  </div>
                  <div class="icon-list-item__content">
                    Manage the payment options for your service and determine how your
                    customer will pay for your service
                  </div>
                </div>
              </div>
            </div>
          </div>
        </collapsible-card>
        <hr class="divider mt-5 mb-4">
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-12">
        <ml-group title="General keys">
          <template slot="content">
            <div class="key-list">
              <developer-key
                title="Service Code"
                :description="`<b>${currentService.serviceName}</b>'s service code`"
                :value="currentService.serviceCode">
              </developer-key>
              <developer-key
                title="Client Code"
                description="Your business client code"
                id="express_checkout_id"
                :value="clientInfo.client_code">
              </developer-key>
            </div>
          </template>
        </ml-group>
      </div>
    </div>

    <div class="row no-gutters my-4">
      <div class="col-12">
        <ml-group title="Express checkout keys">
          <template slot="content">
            <div class="key-list">
              <developer-key
                title="IV Key"
                description="This is one of the pair of keys you need to encrypt your data"
                :value="expressKeys.iv_key">
              </developer-key>
              <developer-key
                title="Secret Key"
                description="This is one of the pair of keys you need to encrypt your data"
                :value="expressKeys.secret_key">
              </developer-key>
              <developer-key
                title="Access Key"
                description="Pass this key when you are sending the parameters to checkout"
                :value="expressKeys.access_key"
                :width="100"
              >
              </developer-key>
            </div>
          </template>
        </ml-group>

      </div>
    </div>

    <div class="row no-gutters my-4">
      <div class="col-12">
        <ml-group title="Custom API keys">
          <template slot="content">
            <div class="key-list">
              <developer-key
                title="Client ID"
                description="You use this as one of the pair of keys you need to generate an access token"
                :value="customApiKeys.client_id">
              </developer-key>
              <developer-key
                title="Client Secret"
                description="This is one of the pair of keys you need to encrypt your data"
                :value="customApiKeys.client_secret">
              </developer-key>
            </div>
          </template>
        </ml-group>
      </div>
    </div>
  </app-shell>
</template>


<script>
  import { mapGetters } from 'vuex'
  import Group from '@/components/Group'
  import Shell from '@/components/Shell'
  import DeveloperKey from '@/components/DeveloperKey'
  import CollapsibleCard from '@/components/CollapsibleCard'

  export default {
    name: 'Home',

    components: {
      'ml-group': Group,
      'app-shell': Shell,
      'developer-key': DeveloperKey,
      'collapsible-card': CollapsibleCard
    },

    computed: {
      ...mapGetters('services', ['currentService']),
      ...mapGetters('user', ['expressKeys', 'customApiKeys', 'clientInfo'])
    },

    methods: {
      goTo (path) {
        if (!this.loading) {
          this.$router.push(path)
        }
      }
    }
  }
</script>


<style lang="scss" scoped>
  .key-list {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue